module.exports = __webpack_public_path__ + "static/news-events-3-411d163d43a05567ae042691561f1e75.jpg";